import React from 'react';
import { CargaDocumentos } from './CargaDocumentos';

export const CardGrid = ({ setCanSign , setErrorMessageKey, setFileName  }) => {
    return (
        <div className="card-grid">
            <CargaDocumentos setCanSign={setCanSign} setErrorMessageKey={setErrorMessageKey} setFileName={setFileName } />
        </div>
    );
};
